/* eslint-disable react/prefer-stateless-function */
import React from 'react';

const Asset = class extends React.Component {
  render() {
    const { img } = this.props;
    return (
      <img src={`/images/assets/asset-${img}.png`} alt="asset" height="20" />
    );
  }
};

export default Asset;
